module.exports = __webpack_public_path__ + "img/page.79bcd4a0.png";